import { ApiEndpoints } from '@/api/apiEndpoints.constant';
import { APP_CONFIG } from '@/config';
import { get } from '@/api/request';
import type { RentDepositInsuranceResponse } from '@/@types/rentDepositInsurance';

export const getRentDepositInsurance = async (): Promise<RentDepositInsuranceResponse> =>
  get<RentDepositInsuranceResponse>(`${APP_CONFIG.baseApiUrl}${ApiEndpoints.rentDepositInsurance}`);
